var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKpiicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9193 28.0215C18.4568 28.0215 13.8478 28.9141 13.8478 32.359C13.8478 35.8054 18.4866 36.6666 23.9193 36.6666C29.3817 36.6666 33.9908 35.774 33.9908 32.3291C33.9908 28.8827 29.352 28.0215 23.9193 28.0215Z",
    fill: "#0070D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.9193 24.7391C27.6182 24.7391 30.5841 21.7562 30.5841 18.0361C30.5841 14.3145 27.6182 11.333 23.9193 11.333C20.2205 11.333 17.2546 14.3145 17.2546 18.0361C17.2546 21.7562 20.2205 24.7391 23.9193 24.7391Z",
    fill: "#0070D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.3892 19.5972C39.3462 15.8329 36.5405 12.4521 32.9679 12.4521C32.5794 12.4521 32.208 12.4949 31.845 12.5676C31.7968 12.5791 31.743 12.6033 31.7146 12.6461C31.682 12.7003 31.7061 12.773 31.7415 12.82C32.8148 14.3343 33.4315 16.178 33.4315 18.1571C33.4315 20.0535 32.8658 21.8216 31.8734 23.2888C31.7713 23.44 31.862 23.6439 32.0421 23.6753C32.2916 23.7195 32.5468 23.7423 32.8077 23.7494C35.4092 23.8178 37.7442 22.1339 38.3892 19.5972Z",
    fill: "#0070D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1147 28.4597C40.6383 27.4388 39.4885 26.7387 37.7405 26.3951C36.9154 26.1926 34.6825 25.9074 32.6055 25.9459C32.5743 25.9502 32.5573 25.9716 32.5545 25.9858C32.5502 26.0058 32.5587 26.04 32.5998 26.0614C33.5596 26.5391 37.2698 28.6166 36.8034 32.9983C36.7835 33.188 36.9352 33.3519 37.1238 33.3234C38.0368 33.1922 40.3859 32.6846 41.1147 31.1033C41.5173 30.2678 41.5173 29.2967 41.1147 28.4597Z",
    fill: "#0070D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.1543 12.5676C15.7927 12.4935 15.4199 12.4521 15.0314 12.4521C11.4588 12.4521 8.65309 15.8329 9.61147 19.5972C10.2551 22.1339 12.5901 23.8178 15.1916 23.7494C15.4525 23.7423 15.7091 23.718 15.9572 23.6753C16.1372 23.6439 16.228 23.44 16.1259 23.2888C15.1335 21.8202 14.5678 20.0535 14.5678 18.1571C14.5678 16.1765 15.186 14.3329 16.2592 12.82C16.2932 12.773 16.3187 12.7003 16.2847 12.6461C16.2563 12.6019 16.2039 12.5791 16.1543 12.5676Z",
    fill: "#0070D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2592 26.3949C8.51112 26.7385 7.36277 27.4386 6.88641 28.4595C6.48236 29.2965 6.48236 30.2676 6.88641 31.1045C7.61512 32.6844 9.96428 33.1935 10.8773 33.3232C11.0659 33.3517 11.2161 33.1892 11.1963 32.9981C10.7299 28.6178 14.44 26.5403 15.4012 26.0626C15.4409 26.0398 15.4494 26.007 15.4452 25.9856C15.4424 25.9714 15.4268 25.95 15.3956 25.9471C13.3172 25.9072 11.0857 26.1924 10.2592 26.3949Z",
    fill: "#0070D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiicon3);
export default __webpack_public_path__ + "static/media/kpiicon3.01316da2db45e89a8eba6d76ba14bdea.svg";
export { ForwardRef as ReactComponent };